import clsx from "clsx";
import React from "react";

import "components/shared/mobile_components.scss";

// TODO All of these components should be in FDS or similar, though keeping in Flight until the full mobile prototype
// is finished as these may be be iterated on substantially.

type MobileCardProps = {
  children: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
};

function MobileCardHorizontalLine({ className }: { className?: string }) {
  return (
    <hr
      className={clsx("my5 bg-black-tint-70 border-none h-px", className)}
      style={{
        // This negates the left inside padding of the card
        marginLeft: "-16px",
        // Max inside size (100%) + double the left padding
        width: "calc(100% + 32px)",
      }}
    />
  );
}

function MobileCard({ children, style, className, ...etc }: MobileCardProps) {
  return (
    <div
      className={clsx(
        className,
        "bg-black-tint-90 text-black-tint-20 p4 m2 vertical-scroll border-box mobile-card",
      )}
      data-testid="mobile-card"
      style={style}
      {...etc}
    >
      {children}
    </div>
  );
}

function VerticalCenter({
  children,
  className = "",
  style = {},
  ...etc
}: {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}) {
  return (
    <div
      {...etc}
      className={clsx("flex items-center justify-center w-full h-full", className)}
      style={style}
    >
      {children}
    </div>
  );
}

export { MobileCardHorizontalLine, MobileCard, VerticalCenter };
